"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTitle = void 0;
var tooltip_title_component_1 = require("./tooltip-title.component");
Object.defineProperty(exports, "TooltipTitle", { enumerable: true, get: function () { return tooltip_title_component_1.TooltipTitle; } });
